import {
    ADD_CATALOG,
    EDIT_CATALOG,
    GET_CATALOGS,
    REMOVE_CATALOG,
    GET_CATALOG_BY_ID,
} from "../actions/catalog-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const catalogReducer = (state = initialState, action: any): ApiRequestState => {
    switch (action.type) {
        case (ADD_CATALOG.REQUEST,
        GET_CATALOGS.REQUEST,
        GET_CATALOG_BY_ID.REQUEST,
        EDIT_CATALOG.REQUEST,
        REMOVE_CATALOG.REQUEST):
            return {
                ...state,
                loading: true,
                error: null,
            };
        case (ADD_CATALOG.SUCCESS,
        GET_CATALOGS.SUCCESS,
        GET_CATALOG_BY_ID.SUCCESS,
        EDIT_CATALOG.SUCCESS,
        REMOVE_CATALOG.SUCCESS):
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case (ADD_CATALOG.FAILURE,
        GET_CATALOGS.FAILURE,
        GET_CATALOG_BY_ID.FAILURE,
        EDIT_CATALOG.FAILURE,
        REMOVE_CATALOG.FAILURE):
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export { catalogReducer };
